import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/logger'; // Init ring-buffer + production silencing before React mounts
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { Analytics } from '@vercel/analytics/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    <Analytics />
  </React.StrictMode>
);
